import * as React from "react";
import { renderFavoritesIcon } from "./renderFavoritesIcon";
import { renderMarketsCount } from "./renderMarketsCount";
export const renderMarketsCountLink = (props, componentPrefix) => {
    return (React.createElement("a", { href: props.linkUrl, onClick: props.handlers.eventCard, className: `rj-ev-list__${componentPrefix}__section rj-ev-list__${componentPrefix}__section--counter`, "data-uat": `a-ev-list-${componentPrefix}-section-counter` },
        props.showFavorites && renderFavoritesIcon(props.isInFavorites, props.handlers.favorites, componentPrefix),
        renderMarketsCount(componentPrefix, props.count)));
};
//# sourceMappingURL=renderMarketsCountLink.js.map